import type { FaireProductEntity } from "../../entity_types/product";

export const p_reqfvpdyt2: FaireProductEntity = {
  token: "p_reqfvpdyt2",
  type: "product",
  name: "Ink Detroit -  Motor City Kitty Toddler Hoodie - Natural Heather",
  brandToken: "b_27pwtoqk4e",
  brandName: "Ink Detroit",
  imageUrl:
    "https://cdn.faire.com/fastly/404de5bf0eb3ea7d5103ca9cf37f24c573d9f6129e18b102de797431725c7ff2.jpeg",
  galleryImageUrls: [],
  priceDollars: 20,
  description:
    "\nInk Detroit - Motor City Kitty Toddler Hoodie - Natural Heather\n\n\nSizes: 2T, 4T, 5/6 \n\nKey Features: \n\n\n * 60% cotton, 40% polyester fleece \n * jersey-lined double-needle hemmed hood \n * topstitched hood and neck \n * coverstitched shoulders, armholes, ribbed cuffs and waistband \n * sideseam pockets \nSize Chart\n\n\n2T 4T 5/6 \nBODY WIDTH 14.5 15.5 16.5 \nFULL BODY LENGTH 15.63 16.63 17.63 \nSLEEVE LENGTH 12 12.75 13.5 ",
  tags: [],
  msrpDollars: 40,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:53:21.099Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
